import React from 'react';
import { Spinner } from 'reactstrap';

const AtomPageLoader = () => {
	return (
		<div className="d-flex w-100 justify-content-center align-item-center">
			<Spinner type="grow" color="primary" />
		</div>
	);
};

export default AtomPageLoader;
